import { defineStore } from 'pinia';
import { useNuxtApp } from "#app";
import { BlogCollectionType } from "~/types/blog/BlogCollectionType";

export const useBlogCollectionStore = defineStore({
    id: 'blogCollection',
    state: (): BlogCollectionType => ({
        list: undefined,
        pagination: undefined,
        error: undefined,
    }),
    getters: {},
    actions: {
        async fetchList(page: number) {
            const pageSize = 12;
            const config = useRuntimeConfig();

            try {
                const fields = ['slug', 'title', 'tags', 'preview_text'];
                const populate = ['preview_image'];
                const sort = ['sorting:desc', 'createdAt:desc'];
                const response = await useNuxtApp().axios.get('/blog-posts', {
                    params: {
                        fields,
                        populate,
                        sort,
                        'pagination[page]': page,
                        'pagination[pageSize]': pageSize,
                    }
                });
                if (response?.data?.data === undefined) {
                    return;
                }

                if (!response?.data?.data.length) {
                    this.list = [];
                    this.error = `There are no posts on page ${page}. Don\'t bully, use the paginator.`;
                    return;
                }

                this.list = response?.data?.data.map(item => ({
                    slug: item?.attributes?.slug,
                    title: item?.attributes?.title,
                    tags: item?.attributes?.tags,
                    previewImage: config.public.mediaBaseUrl + item?.attributes?.preview_image?.data?.attributes?.url,
                    previewText: item?.attributes?.preview_text,
                    url: `/blog/${item?.attributes?.slug}`
                }));
                this.pagination = {
                    page: response?.data?.meta?.pagination?.page,
                    pageCount: response?.data?.meta?.pagination?.pageCount,
                };
                this.error = undefined;
            } catch (error) {
                console.log(error);
                this.error = error.message;
            }

            return true;
        }
    },
});
